// extracted by mini-css-extract-plugin
module.exports = {"container":"_12cTq","wrapper":"_53c1f","title":"_1PA-L","icon":"_2Gr9q"};